import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

import { useTheme } from "styled-components";

const Alert = ({ message }) => {
  const theme = useTheme();

  return (
    <S.Wrapper>
      <GetIcon
        size="sm"
        name="InfoCircle"
        color={theme.colors.feedbackState.info.default}
      />
      <p>{message}</p>
    </S.Wrapper>
  );
};

export default Alert;
